import getEnv from "./getEnv";

const PAGE_SIZE = 10;
const GENDERS = [
  { id: 0, label: "mapping.male", text: "Male", shortLabel: "M", value: 0 },
  { id: 1, label: "mapping.female", text: "Female", shortLabel: "F", value: 1 },
  { id: 2, label: "mapping.other", text: "Other", shortLabel: "O", value: 2 },
];

const PATIENT_REGISTRATION_STANDARD_FIELDS = [
  "patient_id",
  "name",
  "age",
  "gender",
  "contact",
  "dob",
  "email",
  "zip_code",
  "address",
  "additional",
];

const AI_INFERENCE = {
  WAITING_FOR_SCAN: 0,
  PROCESSING: 1,
  NEGATIVE: 2,
  POSITIVE: 3,
  URGENT: 4,
  REJECTED: -1,
  FAILED: -2,
  NA: -3,
};

const STATUS_OPTIONS = [
  // { label: 'Waiting for scan', value: AI_INFERENCE.WAITING_FOR_SCAN },
  { label: "processing", value: AI_INFERENCE.PROCESSING },
  { label: "negative", value: AI_INFERENCE.NEGATIVE },
  { label: "positive", value: AI_INFERENCE.POSITIVE },
  { label: "critical", value: AI_INFERENCE.URGENT },
  { label: "invalid_scan", value: AI_INFERENCE.REJECTED },
  { label: "wte_processing_error", value: AI_INFERENCE.FAILED },
  { label: "not_available", value: AI_INFERENCE.NA },
];

const RN_COMM_CONST = {
  APP_READY: "APP_READY",
  FLUSH_COOKIES: "FLUSH_COOKIES",
  LOGIN: "LOGIN",
  SHARE: "SHARE",
  ENV_SELECTION: "ENV_SELECTION",
  REGION_URL: "REGION_URL",
  OPEN_APP_SETTINGS: "OPEN_APP_SETTINGS",
};

const SCREENS = {
  WORKLIST: "patients",
  VIEWER: "viewer",
};

const MESSAGE_TYPES = {
  MEDIA: "MEDIA",
  STUDY: "STUDY",
  REPORT: "REPORT",
  FORM: "FORM",
  QUESTION: "QUESTION",
  ANSWER: "ANSWER",
  REPORT_SHARING: "REPORT_SHARING",
};

const MEDIA_TYPES = {
  IMAGE: "IMAGE",
  DOCUMENT: "DOCUMENT",
  AUDIO: "AUDIO",
  NA: "NA",
};

const SELECTED_MEDIA_TYPE = ["IMAGE", "DOCUMENT", "STUDY", "REPORT", "FORM", "AUDIO"];

const IMAGE_TYPES = ["jpg", "jpeg", "png", "webp"];

const DOC_TYPES = ["pdf", "msword", "doc", "docx", "xls", "xlsx"];

const AUDIO_TYPES = ["mp3", "mpga", "weba", "webm"];

const PLATFORMS = {
  ANDROID: 0,
  PWA: 1,
  IOS: 2,
};

const FORMS = {
  STROKE_NIHSS: "nihss",
  LUNG_CANCER: "lung_cancer",
  QTRACK_CBNAAT_CLT: "qtrack_cbnaat_clt",
  STROKE_CLINICAL: "stroke_clinical",
  CXR_DATA: "cxr_data",
  LUNG_CANCER_PATHWAY: "lung_cancer_pathway",
  DISCORDANCE: "discordance",
  CT_REFERRAL_AND_AQC: "ct_referral_and_aqc",
  PATIENT_DATA: "patient_data",
  QTRACK_GENEXPERT_CLT: "qtrack_genexpert_clt",
  SYMPTOMS_NEW: "symptoms_new",
  RESIDENCE_DETAILS: "residence_details",
  CARITAS_CONFIRMATION_TEST_CBNAAT: "caritas_confirmation_test_cbnaat",
  CT_DATA: "ct_data",
  TB_VOUCHER: "tb_voucher",
  COUGH_AI_INTERPRETATION: "cough_ai_interpretation",
  DEMOGRAPHIC_DETAILS: "demographic_details",
  PATIENT_SYMPTOMS_MYLABS: "patient_symptoms_mylabs",
  CT_BIOPSY: "ct_biopsy",
  TB_DIAGNOSIS_MYLABS: "tb_diagnosis_mylabs",
  CARITAS_CONFIRMATION_TEST_AFB_SMEAR: "caritas_confirmation_test_afb_smear",
  RISK_GROUPS_NEW: "risk_groups_new",
  SYMPTOMS: "symptoms",
  MRI_REPORT_SUMMARY: "mri_report_summary",
  PATIENT_RISK_GROUPS_MYLABS: "patient_risk_groups_mylabs",
  PAEDIATRICS_TB_CALCULATOR: "paediatrics_tb_calculator",
  RISK_GROUPS: "risk_groups",
  HIV: "hiv",
  COPD_CAT_ASSESSMENT_FORM: "copd_cat_assessment_form",
};

const NOTIFICATION_EVENTS = {
  NEW_PATIENT: 0,
  POSITIVE_FINDINGS: 2,
  NEGATIVE_FINDINGS: 3,
  REPORT_UPDATE: 4,
  STROKE_INITIATED: 5,
  PATIENT_SHARED: 7,
};

const FORM_FIELDS = {
  DUAL_NUMBER: "dual_number",
  NUMBER: "number",
  MULTISELECT: "multiselect",
  CHECKBOX: "check_box",
  SINGLESELECT: "singleselect",
  DATETIME: "datetime",
  LKWT: "lkwt",
};

const DEEFAULT_FILTER = {
  isFilterApplied: false,
  data: null,
  label: "",
};

const DICOM_METADATA_TAGS = {
  SOPInstanceUID: "x00080018",
  SOPClassUID: "x00080016",
  StudyInstanceUID: "x0020000d",
  SeriesInstanceUID: "x0020000e",
  Modality: "x00080060",
  PatientID: "x00100020",
  AccessionNumber: "x00080050",
  PatientName: "x00100010",
  PatientGender: "x00100040",
  PatientAge: "x00101010",
  StudyDescription: "x00081030",
  SeriesDescription: "x0008103e",
  StudyDate: "x00080020",
};

const REQUIRED_DICOM_METADATA = [
  "SOPInstanceUID",
  "SOPClassUID",
  "SeriesInstanceUID",
  "StudyInstanceUID",
  "Modality",
  "PatientID",
];

const TESTING_REGIONS = [
  "localhost",
  "dev2-app.qure.ai",
  "alpha-app.qure.ai",
  "beta-app.qure.ai",
  "vercel.app",
];

const COUNTRY_CODE = "+91";

const PERSISTED = {
  isFullWidthWorklist: "isFullWidthWorklist",
  filterObj: "filterObj_new",
  savedFilterData: "savedFilterData_new",
  isDarkMode: "isDarkMode",
  isSwiftReportModeEnabled: "isSwiftReportModeEnabled",
  notificationPromptDismiss: "notificationPromptDismiss",
  fcmToken: "fcmToken",
  redirectAfterLogin: "redirectAfterLogin",
  patientSearch: "patientSearch",
  otpLoginSuccess: "otpLoginSuccess",
  requestedWorkspaceData: "requestedWorkspaceData",
  mixpanelEvents: "mixpanelEvents",
  qSyncEventLogged: "qSyncEventLogged",
};

const DEFAULT_FILTER_NAME = {
  negativeCXR: "Review Negative CXR",
};

const MPPS_STATUS = {
  DISCONTINUED: "DISCONTINUED",
  COMPLETED: "COMPLETED",
  IN_PROGRESS: "IN PROGRESS",
  REGISTERED: "REGISTERED",
};
const TERMS_OF_USE_VERSION = "2.0.4";

const UPLOAD_UI_STATE = {
  BROWSE_FILE: "BROWSE_FILE",
  CROP_FILE: "CROP_FILE",
  CROP_COMPLETE: "CROP_COMPLETE",
};

const UPLOAD_STATE = {
  NOT_STARTED: "NOT_STARTED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETE: "COMPLETE",
  FAILED: "FAILED",
  FAILED_LOW_RES: "FAILED_LOW_RES",
};

const GATEWAY_TIME = {
  TIME_DIFFERENCE: 16,
};

const ERROR_TYPE = {
  ERROR: "ERROR",
  WARNING: "WARNING",
  VIEWER_FEEDBACK: "VIEWER_FEEDBACK",
};

const AUTO_SHARING_SECTIONS = {
  modalities: ["modality"],
  findings: ["qxr", "qer", "qct", "qmsk"],
  patient_status: ["emergency", "forms"],
};

const PULL_TO_REFRESH = {
  resistance: 3,
  maxPullDownDistance: 100,
};

const SYNC_STATUS = {
  ONPREMISE: {
    SYNCED: "SYNCED",
    IN_PROGRESS: "IN_PROGRESS",
    NO_INTERNET: "NO_INTERNET",
  },
  CLOUD: {
    UNREAD: "UNREAD",
    READ: "READ",
  },
  ERROR: {
    DISABLED: "sync_disabled",
    NEVER_STARTED: "never_started",
  },
};

// Sync status color classes - static strings for better performance on OnPrem devices
const SYNC_STATUS_COLORS = {
  IN_PROGRESS: {
    icon: "text-gray-500 dark:text-gray-400 text-base",
    pill: "bg-gray-200 dark:bg-gray-800 text-gray-700 dark:text-gray-200 border border-teal-500",
    header: "bg-gray-200 dark:bg-gray-700",
  },
  SYNCED: {
    icon: "text-green-500 dark:text-green-600 text-base",
    pill: "bg-green-200 dark:bg-green-900 text-gray-900 dark:text-gray-100",
    header: "bg-green-200 dark:bg-green-800",
  },
  NO_INTERNET: {
    icon: "text-base text-gray-700 dark:text-gray-300",
    pill: "bg-yellow-400 dark:bg-yellow-800 text-gray-700 dark:text-gray-100",
    header: "bg-yellow-300 dark:bg-yellow-800",
  },
  DEFAULT: {
    icon: "text-base text-gray-400 dark:text-gray-300",
    pill: "bg-gray-200 dark:bg-gray-800 text-gray-700 dark:text-gray-200",
    header: "",
  },
};

// Sync auto-open configuration
const SYNC_AUTO_OPEN = {
  // Use a getter to evaluate threshold at runtime instead of module load time
  get THRESHOLD_DAYS() {
    return parseInt(getEnv("NEXT_PUBLIC_SYNC_WARNING_THRESHOLD_DAYS") || "15", 10);
  },
  DELAY_MS: 3000,
  STORAGE_KEY: "syncDropdownAutoOpened",
};

const FORM_NAMES = {
  qxr: "Tuberculosis",
  qer: "Neurology - Stroke evaluation",
  lung_cancer: "Lung Cancer",
  qct: "qCT",
  default: "Clinical Forms",
  mylabs: "Forms",
  copd: "COPD",
};

const SETTINGS = {
  NOTIFICATIONS: "notifications",
  AUTOMATED_SHARING: "automated-sharing",
  USER_GROUPS: "user-groups",
  GATEWAY: "gateway",
  FORM_TEMPLATES: "form-templates",
  REPORT_TEMPLATE: "report-template",
  MODALITY_CONNECT: "modality-connect",
  THEME: "theme",
  WORKLIST_TAGS: "worklist-tags",
  WORKSPACE_MANAGEMENT: "workspace-management",
  SITE_MANAGEMENT: "site-management",
  EXPORT_DATA: "export-data",
  SUPPORT: "support",
  REGION: "region",
  TERMS_OF_USE: "terms-of-use",
  REMOTE_ACCESS: "remote-access",
  SCAN_TO_CONNECT: "scan_to_connect",
  DISK_MANAGEMENT: "disk-management",
  LICENSE_MANAGER: "license",
  CUSTOM_TAGS_MANAGEMENT: "custom-tags-management",
};

const WORKSPACE_USER_ROLES = {
  WORKSPACE_PATIENT_READ: "WORKSPACE_PATIENT_READ",
  WORKSPACE_PATIENT_WRITE: "WORKSPACE_PATIENT_WRITE",
  WORKSPACE_PATIENT_UPLOAD: "WORKSPACE_PATIENT_UPLOAD",
  WORKSPACE_AUTOSHARING: "WORKSPACE_AUTOSHARING",
  WORKSPACE_MANAGEMENT: "WORKSPACE_MANAGEMENT",
  WORKSPACE_EXPORT_DATA: "WORKSPACE_EXPORT_DATA",
  WORKSPACE_DASHBOARD: "WORKSPACE_DASHBOARD",
  WORKSPACE_GATEWAY_INDICATORS: "WORKSPACE_GATEWAY_INDICATORS",
  WORKSPACE_FORM_SETTINGS: "WORKSPACE_FORM_SETTINGS",
};

const VIEWER_LABEL = {
  ZOOM: "Zoom",
  MAGNIFY: "Magnify",
  WINDOW_LEVEL: "Window Level",
  WINDOW_LEVEL_PRESET: "WindowLevel",
  ALTERNATE_NAME_FOR_WINDOW_LEVEL: "Wwwc",
  LENGTH: "Length",
  BIDIRECTIONAL: "Bidirectional",
  ANNOTATION: "Annotation",
  ELLIPSE: "Ellipse",
  ARROW_ANNOTATION: "ArrowAnnotate",
  ELLIPTICALROI: "EllipticalROI",
  ANGLE: "Angle",
  ROTATE_RIGHT: "Rotate Right",
  ROTATE_LEFT: "Rotate Left",
  FLIP_HORIZONTAL: "Flip Horizontal",
  FLIP_VERTICAL: "Flip Vertical",
  INVERT: "Invert",
  PAN: "Pan",
  GRID_LAYOUT: "Grid Layout",
  PROBE: "Probe",
  STACK_SCROLL: "Stack Scroll",
  CINE_TOOL: "Cine tool",
  RESET: "Reset",
  DEFAULT: "Default",
  SOFT_TISSUE: "Soft tissue",
  LUNG: "Lung",
  LIVER: "Liver",
  BONE: "Bone",
  BRAIN: "Brain",
  SUBDURAL: "Subdural",
  STROKE: "Stroke",
  TEMPORAL_BONES: "Temporal Bones",
};

const FORM_FIELD_TYPES = {
  multiple_choice: "string[]",
  textarea: "string",
  choice: "string",
  nihss_choice: "string",
  dropdown: "string",
};

const FALLBACK_IMAGE_URL = "/assets/icons/dcmPlaceholder.svg";

export default {
  PAGE_SIZE,
  GENDERS,
  PATIENT_REGISTRATION_STANDARD_FIELDS,
  AI_INFERENCE,
  RN_COMM_CONST,
  STATUS_OPTIONS,
  SCREENS,
  MESSAGE_TYPES,
  MEDIA_TYPES,
  IMAGE_TYPES,
  DOC_TYPES,
  AUDIO_TYPES,
  PLATFORMS,
  FORMS,
  NOTIFICATION_EVENTS,
  FORM_FIELDS,
  DEEFAULT_FILTER,
  DICOM_METADATA_TAGS,
  REQUIRED_DICOM_METADATA,
  PERSISTED,
  TERMS_OF_USE_VERSION,
  DEFAULT_FILTER_NAME,
  MPPS_STATUS,
  UPLOAD_UI_STATE,
  UPLOAD_STATE,
  GATEWAY_TIME,
  ERROR_TYPE,
  AUTO_SHARING_SECTIONS,
  PULL_TO_REFRESH,
  SELECTED_MEDIA_TYPE,
  SYNC_STATUS,
  SYNC_STATUS_COLORS,
  SYNC_AUTO_OPEN,
  FORM_NAMES,
  SETTINGS,
  COUNTRY_CODE,
  TESTING_REGIONS,
  WORKSPACE_USER_ROLES,
  VIEWER_LABEL,
  FORM_FIELD_TYPES,
  FALLBACK_IMAGE_URL,
};
